export default __webpack_public_path__ + "static/media/941.09fdd7f7.gif";